export const TAXONOMIES = [
    {
        post_type: 'event',
        endpoint: {
            posts: '/wp-json/botw/v1/whats-on/',
            facets: '/wp-json/botw/v1/whats-on-filters/'
        },
        taxonomies: [
            {
                key: "event_genre",
                label: "Genre(s)",
                placeholder: "Select a genre"
            },
            {
                key: "event_type",
                label: "Type(s)",
                placeholder: "Select an event type"
            },
            {
                key: "venue",
                label: "Venue(s)",
                placeholder: "Select a venue"
            },
        ]
    },
    {
        post_type: 'mediapost',
        endpoint: {
            posts: '/wp-json/botw/v1/mediaposts/',
            facets: '/wp-json/botw/v1/mediaposts-filters/'
        },
        taxonomies: [
            {
                key: "project",
                label: "Project(s)",
                placeholder: "Select a project"
            },
            {
                key: "media_type",
                label: "Type(s)",
                placeholder: "Select a content type"
            },
            {
                key: "theme",
                label: "Theme(s)",
                placeholder: "Select a theme"
            }
        ]
    }
];

export function getPostTypeConfig(postType) {
    return TAXONOMIES.find(t => t.post_type === postType);
}

export const MONTHS = (() => {
    const months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

    const result = [];
    const now = new Date();
    let year = now.getFullYear();
    let month = now.getMonth(); // 0–11

    for (let i = 0; i < 12; i++) {
        const monthIndex = (month + i) % 12;
        const displayYear = year + Math.floor((month + i) / 12);
        const key = `${displayYear}-${String(monthIndex + 1).padStart(2, "0")}`;

        result.push({
            key: key,
            label: months[monthIndex],
        });
    }

    return result;
})();
